'use strict';
import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';

const customLayout = {
  'login': [ [1, 2, 3, 4, 5, 'b'], [6, 7, 8, 9, 0, 'a']],
  'default' : [ [1, 2, 3, 4, 5, '.'], [6, 7, 8, 9, 0, 'b']]
};

class VirtualKeyboard extends Component {

  handleKeyboard = (val) => {
    this.props.onChange(val);
  }

  render() {

    const layout = this.props.type ? this.props.type : 'default';

    return (
      <div className="ui-keyboard" role="textbox">
        <div className="ui-keyboard-keyset">
          { customLayout[layout].map( el => 
            <Fragment key={el[0]}>
              <Buttons items={el} handleClick={this.handleKeyboard}/>
              <br className="ui-keyboard-button-endrow" />
            </Fragment>
          )}
        </div>
    </div>
    )
  }
}

export default VirtualKeyboard;

const Buttons = ({items, handleClick}) => {
  let buttons = items.map( el => {
    if (el == 'b') {
      return <div onClick={() => handleClick(el)} key={el} tabIndex="-1" className="ui-keyboard-button ui-keyboard-bksp" title="Backspace"><span className="ui-keyboard-text">⌫</span></div> 
    } else if (el == 'a') {
      return <div onClick={() => handleClick(el)} key={el}  tabIndex="-1" className="ui-keyboard-button ui-keyboard-accept"><span className="ui-keyboard-text">✔</span></div> } 
    else {
      return <div onClick={() => handleClick(el)} key={el}  tabIndex="-1" className="ui-keyboard-button"><span className="ui-keyboard-text">{el}</span></div>
    }
  })

  return buttons;
}


// WEBPACK FOOTER //
// ./src/components/keyboard/keyboard.jsx